import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getMyClasses, joinClassroom } from '../../api/class';
import { UserNav } from '../../components';

const MyClasses = () => {
    const { user } = useSelector((state) => ({ ...state }))
    const [loading, setLoading] = useState(true)
    const [myClasses, setMyClasses] = useState([])
    const [room_ID, setRoom_ID] = useState('')
    const history = useHistory()

    useEffect(() => {
        loadMyClasses()
    }, [])

    const loadMyClasses = () => {
        setLoading(true)
        getMyClasses(user._id)
            .then(res => {
                setMyClasses(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
                setLoading(false)
            })
    }

    const handleSubmit = e => {
        e.preventDefault()
        joinClassroom(user._id, user.token, room_ID)
            .then(res => {
                toast.success("Successfully joined the class")
                console.log(res.data)
                setRoom_ID('')
                loadMyClasses()
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
                setLoading(false)
            })
    }

    const gotoMyCLass = myclass => {
        history.push(`/my/${myclass._id}/class`)
    }

    return (<div className="my-classes">
        <div className="row">
            <div className="col-md-2">
                <UserNav />
            </div>
            <div className="col-md-10">
                <div className="join-room-div">
                    <form id='new-class-form' onSubmit={handleSubmit}>
                        <div class="class-input">
                            <label htmlFor="room-id" class="form-label">Room ID*</label>
                            <input type="text" name="room_ID" class="form-control" id="room-id" onChange={e => setRoom_ID(e.target.value)} value={room_ID} aria-describedby="emailHelp" />
                            {/* <div id="emailHelp" class="form-text">Should be unquie</div> */}
                        </div>
                        <div class="class-input">
                            <button type="submit" class="btn btn-primary">Join</button>
                        </div>
                    </form>
                </div>
                {
                    loading ? <h1>loading</h1> : (
                        <div className="all-my-classes-div" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '5vh', justifyContent: 'space-evenly' }}>
                            {
                                (myClasses && myClasses.length) ? (
                                    myClasses.map((each, i) => {
                                        return (
                                            <div key={i} style={{ minWidth: '200px', minHeight: '200px', padding: '2em' }} className="card text-center">
                                                <div className="card-body">
                                                    <p className="card-text">Room-ID: {each.room_ID}</p>
                                                    <h5 className="card-title">{each.name}</h5>
                                                    <button onClick={e => { e.preventDefault(); gotoMyCLass(each) }} className="btn btn-primary">Open</button>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : ''
                            }
                        </div>
                    )
                }
            </div>
        </div>
    </div>);
};

export default MyClasses;